import {useEffect, useRef, useState} from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import s from "./CategoryFixedMobile.module.scss";
import alllCategories from "../../assets/all_cats.png";

const CategoryFixedMobile = ({categories, onCategoryClick, activeCategory}) => {
    const listRef = useRef(null);
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);

    const updateScrollButtons = () => {
        const el = listRef.current;
        if (!el) {
            return;
        }

        setCanScrollPrev(el.scrollLeft > 0);
        setCanScrollNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };

    useEffect(() => {
        updateScrollButtons();
        window.addEventListener("resize", updateScrollButtons);

        return () => {
            window.removeEventListener("resize", updateScrollButtons);
        };
    }, [categories]);

    const scrollCategories = (direction) => {
        const el = listRef.current;
        if (!el) {
            return;
        }

        el.scrollBy({
            left: direction * el.clientWidth,
            behavior: "smooth",
        });
    };

    return (
        <div className={s.mobileCarousel}>
            <button
                type="button"
                className={`${s.navButton} ${s.prev}`}
                onClick={() => scrollCategories(-1)}
                disabled={!canScrollPrev}
                aria-label="Previous categories"
            >
                <KeyboardArrowLeftIcon fontSize="small"/>
            </button>

            <div className={s.categoryList} ref={listRef} onScroll={updateScrollButtons}>
                <div
                    key={"all"}
                    className={`${s.item} ${activeCategory === null ? s.active : ""}`}
                    onClick={() => {
                        onCategoryClick("");
                    }}
                >
                    <div className={s.card}>
                        <img src={alllCategories} alt=""/>
                        <div className={s.overlayBelow}>
                            <div className={s.overlayBelowText}>すべてのツアー</div>
                        </div>
                    </div>
                </div>

                {categories.slice(0, 7).map((item, i) => (
                    <div
                        key={i}
                        className={`${s.item} ${String(activeCategory) === String(item.id) ? s.active : ""}`}
                        onClick={() => {
                            onCategoryClick(item.id);
                        }}
                    >
                        <div className={s.card}>
                            <img src={item.thumb} alt=""/>
                            <div className={s.overlayBelow}>
                                <div className={s.overlayBelowText}> {item.name}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <button
                type="button"
                className={`${s.navButton} ${s.next}`}
                onClick={() => scrollCategories(1)}
                disabled={!canScrollNext}
                aria-label="Next categories"
            >
                <KeyboardArrowRightIcon fontSize="small"/>
            </button>
        </div>
    );
};

export default CategoryFixedMobile;
